import { createContext } from "react";
const OurClientContext = createContext({});
export default OurClientContext;
